import { render, staticRenderFns } from "./SectionStories.vue?vue&type=template&id=1ddf8857&scoped=true"
import script from "./SectionStories.vue?vue&type=script&lang=js"
export * from "./SectionStories.vue?vue&type=script&lang=js"
import style0 from "./SectionStories.vue?vue&type=style&index=0&id=1ddf8857&prod&scoped=true&lang=scss"
import style1 from "./SectionStories.vue?vue&type=style&index=1&id=1ddf8857&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf8857",
  null
  
)

export default component.exports